import ScreenLock from "./ScreenLock";

import "./ScreenLock.scss";

export { ScreenLock };

